/*
Copyright (c) 2024, HP Development Company, L.P. All rights reserved.
This software contains confidential and proprietary information of HP.
The user of this software agrees not to disclose, disseminate or copy
such Confidential Information and shall use the software only in accordance
with the terms of the license agreement the user entered into with HP.
*/

import React, { memo } from 'react';
import { Toggle as VToggle } from '@veneer/core';
import './styles.scss';
import { withAnalytics } from '@veneer/analytics';
import { ToggleProps } from './types';
import { generateID } from '../../base/helper';

const TToggle: React.FC<ToggleProps> = ({
  id = generateID('clientos-ui-toolkit-toggle'),
  ...rest
}) => {
  return (
    <div
      className={`clientos-ui-toolkit-custom-toggle`}
      id={id}
    >
      <VToggle
        id={`${id}__toggle`}
        {...rest}
      />
    </div>
  );
};

export const ToggleAnalytics = withAnalytics(TToggle);
export default memo(TToggle);
